import React from 'react'

import { Container } from './style'

export default function AuthLayout({ children }: any) {
  return <Container>{children}</Container>
}
